import {SA_TRAVEL_FIELDS_MASTER_LIST, SA_TRAVEL_FIELDS_MASTER_CREATE, SA_TRAVEL_FIELDS_MASTER_MODIFY, SA_TRAVEL_FIELDS_MASTER_DELETE, AFFILIATE_TRAVEL_SETTINGS_LIST} from '../index';

export const travelFieldsMasterListAction = (data) => {
    return {
        type: SA_TRAVEL_FIELDS_MASTER_LIST,
        data
    }
};

export const travelFieldCreateAction = (data) => { 
    return {
        type: SA_TRAVEL_FIELDS_MASTER_CREATE,
        data
    }
};

export const travelFieldModifyAction = (data) => { 
    return {
        type: SA_TRAVEL_FIELDS_MASTER_MODIFY,
        data
    }
};

export const travelFieldDeleteAction = (data) => { 
    return {
        type: SA_TRAVEL_FIELDS_MASTER_DELETE,
        data
    }
};

export const affiliateTravelSettingsAction = (data) => { 
    return {
        type: AFFILIATE_TRAVEL_SETTINGS_LIST,
        data
    }
};




